import {
    getPolopolyVideoByLineupSlug,
    getVideoItemsByCategorySlugs,
} from "../../fetch/graphql/requests/video/library";
import { getContextualOverridesBySlug } from "../../utils/dataTransform/utils";
import { gqlMediaAspectRatios } from "../PlaylistWidget/constants";
import { fetchForYouVerticalVideos } from "../../fetch/graphql/requests/shortsWidget/library";
import { getUserFromCookie } from "../../utils/cookies/library";
import {
    ContextualOverride,
    TransformedCardData,
} from "../../stories/Components/Card/interface";
import {
    CategoryShortsFetchFn,
    GetContexualOverridesFn,
    PlaylistFetchFn,
    UserCookie,
    VideoLineupFetchFn,
} from "./interface";

const typecastVideoFetch: VideoLineupFetchFn = getPolopolyVideoByLineupSlug;
const typecastGetContextualOverrides =
    getContextualOverridesBySlug as GetContexualOverridesFn;
const typecastCategoryFetch: CategoryShortsFetchFn =
    getVideoItemsByCategorySlugs;
const typecastForYouFetch: PlaylistFetchFn = fetchForYouVerticalVideos;

const transformContentItemForPlaylist = (
    lineupSlug: string,
    data: TransformedCardData[]
) => {
    return data.map((item: TransformedCardData) => {
        const overrides: ContextualOverride | null =
            typecastGetContextualOverrides(
                lineupSlug,
                item?.contextualOverrides
            );

        return {
            ...item,
            title: overrides?.headline || item.title,
        };
    });
};

export const fetchVideoByLineupFactory = (
    lineupSlug: string,
    pageSize = 20,
    mediaAspectRatios = [gqlMediaAspectRatios.ratio16By9]
) => {
    if (!lineupSlug) {
        throw new Error("fetchVideoLineupFactory: lineupSlug is required");
    }

    return () => {
        return typecastVideoFetch(lineupSlug, pageSize, mediaAspectRatios).then(
            (data) => {
                const responseItems = data?.allContentItems?.nodes || [];
                if (responseItems.length === 0) {
                    return [];
                }
                const transformedItems = transformContentItemForPlaylist(
                    lineupSlug,
                    responseItems
                );
                return transformedItems;
            }
        );
    };
};

export const fetchVideoByCategoryFactory = (
    category: string,
    pageSize = 20,
    mediaAspectRatios = [gqlMediaAspectRatios.ratio16By9]
) => {
    if (!category) {
        throw new Error(
            "fetchVerticalVideoCategoryFactory: category is required"
        );
    }

    return () => {
        const categorySlugs = [category];

        return typecastCategoryFetch(
            categorySlugs,
            pageSize,
            undefined,
            mediaAspectRatios
        ).then((response) => {
            /* eslint-disable */
            const responseItems = response?.data?.allContentItems?.nodes || [];
            if (responseItems.length === 0) {
                return [];
            }
            const transformedItems = transformContentItemForPlaylist(
                categorySlugs[0],
                responseItems
            );
            return transformedItems;
            /* eslint-enable */
        });
    };
};

export const fetchAndParseForYouVideos = () => {
    const user: UserCookie | null = getUserFromCookie() as UserCookie | null;
    const userId = user?.id;

    if (!userId) {
        return Promise.reject([]);
    }
    return typecastForYouFetch(userId).then((response) => {
        /* eslint-disable */
        return response?.data?.personalizedItems?.nodes || [];
        /* eslint-enable */
    });
};
